import React, {useCallback, useMemo} from 'react';
import {Modal} from 'antd';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import ModelDownload from './ModelDownload';
import {ModelDetailActionProps} from '../../../actionMenuTypes';
import {isModelTheorem} from '../../../../../store/model';
import ModelDownloadTH from './ModelDownloadTH';

export const useModelDownloadSideBarModal = (props: Partial<ModelDetailActionProps>) => {
  const {model, onSuccess} = props;
  const {buttonRef, openModal, closeModal} = useSideBarModal(model?.uuid);
  const theoremModel = isModelTheorem(model);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model && (
        <Modal
          open={!!buttonRef}
          onCancel={closeModal}
          footer={null}
          title={null}
          width={560}
          centered
          closable={false}
          maskClosable={false}
          destroyOnHidden
          styles={{content: {padding: '32px'}}}
        >
          {!!buttonRef && theoremModel ? (
            <ModelDownloadTH model={model} onSuccess={handleSuccess} onCancel={closeModal} />
          ) : (
            <ModelDownload model={model} onSuccess={handleSuccess} onCancel={closeModal} />
          )}
        </Modal>
      )
    );
  }, [buttonRef, model, handleSuccess, closeModal, theoremModel]);

  return {
    openModal,
    ModalComponent,
  };
};
